import { IconNames } from "@blueprintjs/icons";

import DropdownSelect from "./common/DropdownSelect";

export default DropdownSelect.withOptions([
	{value: "flex-start", label: "Start", icon: IconNames.ALIGNMENT_LEFT},
	{value: "center", label: "Center", icon: IconNames.ALIGN_CENTER},
	{value: "flex-end", label: "End", icon: IconNames.ALIGNMENT_RIGHT},
	{value: "space-between", label: "Justify (Between)", icon: IconNames.ALIGN_JUSTIFY},
	{value: "space-around", label: "Justify (Around)", icon: IconNames.ALIGN_JUSTIFY},
	{value: "space-evenly", label: "Justify (evenly)", icon: IconNames.ALIGN_JUSTIFY}
]);



// WEBPACK FOOTER //
// ./src/common/form/widgets/CssJustifyWidget.tsx